/*globals google*/
/*globals Highcharts*/
(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('TravelController', TravelController);
    

    TravelController.$inject = [
        '$timeout',
        'NgMap',
        'fleet',
        'endPoints',
        '$stateParams',
        '$q',
        'genericDataService', 
        '$scope',
        '$rootScope',
        'common'
    ];

    /* jshint maxstatements:false */
    function TravelController(
        $timeout,
        NgMap,
        fleet,
        endPoints,
        $stateParams,
        $q,
        genericDataService, 
        $scope,
        $rootScope,
        common
    ) {

        var STEP_SPEED = 200; //50 milliseconds per step
        var MIN_ZOOM = 16;
        var MARKER_ZOOM = 12;

        /* PRIVATE VARIABLES */
        var flotaIdParam = $stateParams.flotaId;
        var timeParam = $stateParams.time;
        var step = 0;
        var plotLine= null;
        var timeout = null;
        var markers = [];

        /* PUBLIC VARIABLES */
        var vm = this;

        vm.dateRange = $.extend({}, common.defaultDateRangePickerOptions);

        vm.wasOpened = false; 

        vm.data = [];
        vm.speedMultiplier = 1;
        vm.selectedData = [];
        vm.mapData = [];
        vm.flota = {
            list: null,
            selected: { id: null }
        };

        vm.titleCombo = 'Seleccione Vehículo';
        vm.fechaInicio = Date.NewDate();
        vm.fechaFin = Date.NewDate();
        vm.play = false;
        vm.googleApiURL = endPoints.GOOGLE_MAPS_API_URL;

        vm.map = {
            center: {
                latitude : 40.0434099,
                longitude : -5.6283385
            },
			zoom: 6,
        };
        vm.mapZoom = -1;

        vm.chartConfig = {
            chart: {
                events: {
                    
                    selection: function(event) {
                            if (event.xAxis) {
                                var extremesObject = event.xAxis[0];
                                var min = extremesObject.min;
                                var max = extremesObject.max;
                                
                                addSelection(min, max);
                                return false;
                            }
                        },
                        click: function(event) {
                            chartClick(event.xAxis[0].value);
                        }
                },
                zoomType: 'x'
            },
            title: {
                text: null
            },
            subtitle: {
                text: null
            },
            xAxis: {
                type: 'datetime'
            },
            yAxis: {
                title: {
                    text: null
                },
                labels: {
                    formatter: function() {
                        return this.value + ' Km/h';
                    }
                }
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                area: {
                    marker: {
                        radius: 2
                    },
                    lineWidth: 1,
                    states: {
                        hover: {
                            lineWidth: 1
                        }
                    },
                    threshold: null
                }
            },

            series: [{
                data: vm.data,
                turboThreshold: 0,
                name: 'Velocidad'
            }],
            credits: {
                enabled: false
            }
        };


        /* PUBLIC FUNCTIONS */
        vm.markerClick = markerClick;
        vm.selectAyer = selectAyer;
        vm.selectHoy = selectHoy;
        vm.select24H = select24H;
        vm.mostrarRecorrido = mostrarRecorrido;
        vm.simularRecorrido = simularRecorrido;
        vm.pauseAction = pauseAction;
        vm.playAction = playAction;
        vm.steps = steps;
        vm.lastStep = lastStep;
        vm.firstStep = firstStep;
        vm.getMarketIcon = getMarketIcon;
        vm.getCurrentData = getCurrentData; 
        vm.toggleGraph = toggleGraph;
        vm.loading = false;
        vm.showDetail = showDetail;
        vm.hideDetail = hideDetail;
        vm.iconTypeOrder = iconTypeOrder;
        vm.onSelectVehiculosClick = onSelectVehiculosClick;

        /* INITIALIZER */
        (function () {
            genericDataService.getFlota()
                .then(function (res) {
                    vm.flota.list = res;

                    var find = findByProperty(vm.flota.list, 'id', flotaIdParam);
                    if (find) {
                        vm.flota.selected.nombre = find.nombre;
                        vm.flota.selected.id = find.id;

                        var loadTravel = true;
                        switch(timeParam){
                            case 'today':
                                selectHoy();
                                break;
                            case 'yesterday':
                                selectAyer();
                                break;
                            case 'last24':
                                select24H();
                                break;
                            default:
                                loadTravel = false;
                                break;
                        }
                        if(loadTravel){ mostrarRecorrido(); }

                    } else {
                        vm.flota.selected.nombre = null;
                        vm.flota.selected.id = null;
                    }
                });

            NgMap.getMap('mapaRecorridos').then( function(map){
                map.addListener('zoom_changed', function() {
                    var lastZoom = vm.mapZoom;
                    vm.mapZoom = map.getZoom();
                    if(lastZoom > 0 && ((lastZoom <= MARKER_ZOOM && vm.mapZoom > MARKER_ZOOM) || 
                        (vm.mapZoom <= MARKER_ZOOM && lastZoom > MARKER_ZOOM))){
                        drawMarkers();
                    }
                });
            });

            $scope.$on('detail-resize', function(event, args) { 
                if ($rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('recorridos')].isActive()) {
                    $timeout(function(){ resizeMap(); },0);
                }
            });

            $scope.$on('$destroy', function() {
                
                //console.log(mymarker);
                //mymarker.setMap(null);
                //$scope.google.maps.event.clearListeners(m, 'zoom_changed');

                for(var i = 0; i < markers.length; i++){
                    markers[i].setMap(null);
                }
                markers = [];

                vm = null;
            });

        })();


        /* FUNCTION DEFINITIONS */
        function toggleGraph() {
            vm.hideGraph = !vm.hideGraph;
            $timeout(function(){ resizeMap(); },0);
        }

        function markerClick(event, index) {

            if(index === null){ index = step; }
            var position = vm.selectedData[index];
            
            vm.fleetId = position.fleetId;
            vm.fleetPlate = position.matricula;
            vm.operatorId = position.idOperator;
            vm.operatorName = position.nameOperator;
            vm.stepDate = position.lastPositionDate;
            vm.stepHour = moment(position.lastPositionDate).format('HH:mm');
            vm.speed = position.speed;
            vm.power = position.gpio2? 'Arrancado' : 'Parado';

            //si quiere el cartel siempre se quita la condición
            if(!vm.play){
                getAddress(position.lat, position.lng).then(function(address){
                    vm.address = address;
                });
            }else{
                vm.address = '-';
            }

            vm.distance = Math.round((position.dist - vm.selectedData[0].dist)/ 1000 * 100) / 100;
        }
        
        function selectAyer(){
            var today = Date.NewDate();
            vm.fechaInicio = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 0, 0, 0);
            vm.fechaFin = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
            vm.option = 2;
        }

        function selectHoy(){
            var today = Date.NewDate();
            vm.fechaInicio = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
            vm.fechaFin = today;
            vm.option = 1;
        }

        function select24H(){
            var today = Date.NewDate();
            vm.fechaInicio = Date.NewDate(); vm.fechaInicio.setHours(vm.fechaInicio.getHours() - 24);
            vm.fechaFin = today;
            vm.option = 3;
        }

        function mostrarRecorrido() {

            if (!vm.flota.selected.id || !vm.fechaInicio || !vm.fechaFin) { return; }
            vm.loading = true;
            getRecorridoData(vm.flota.selected.id, vm.dateRange.fromDate, vm.dateRange.toDate).then(function (data) {
                goToStepEnd();
                vm.loading = false;
            });
        }

        function simularRecorrido(){
            goToStep(0);
            vm.play = true;
            takeStep();
        }

        function playAction(){
            if(step === vm.selectedData.length - 1){
                vm.firstStep();
            }
            vm.play = true;
            takeStep();
        }

        function pauseAction(e){
            vm.play = false;
        }

        function steps(n, dir){
            vm.play = false;
            if(dir){
                goToStep(step + n);
                vm.map.center.latitude = vm.selectedData[step].lat;
                vm.map.center.longitude = vm.selectedData[step].lng;
            }else{
                goToStep(step - n);
                vm.map.center.latitude = vm.selectedData[step].lat;
                vm.map.center.longitude = vm.selectedData[step].lng;
            }
        }

        function lastStep(){
            goToStepEnd();
        }

        function firstStep(){
            goToStep(0);
        }

        function takeStep(){
            goToStep(step + 1);
            vm.map.center.latitude = vm.selectedData[step].lat;
            vm.map.center.longitude = vm.selectedData[step].lng;

            if(step >= vm.selectedData.length - 1){
                vm.play = false;
            }

            if(vm.play && timeout === null){
                timeout = $timeout(takeStepPlay, STEP_SPEED * vm.speedMultiplier);
            }
        }
        function takeStepPlay(){
            timeout = null;
            takeStep();
        }

        function getRecorridoData(flotaId, start, finish){
            var deferred = $q.defer();
            start = start.toISOString();
            finish = finish.toISOString();
            fleet.getRecorrido(flotaId, start, finish).then(function (data) {
                parseDataForChart(data);
                vm.data = data; 
                vm.selectedData = data;
                addMarkers();
                vm.chartConfig.series[0].data = vm.data;
                zoomToIncludeMarkers();
                deferred.resolve(data); 

            }, function(data){ deferred.reject(data); });
            return deferred.promise;
        }

        function getCurrentData(){
            return vm.selectedData[step];
        }

        function getMarketIcon(data, index) {
            /* jshint maxcomplexity:false */
            var scale = 1;
            var size = {x:20,y:20};
            var typeIcon;
            var anchorPoint = null;

            if(index === 0){
                typeIcon = 'start-route';
                size={x:15,y:20};
                scale=1.5;
                anchorPoint = {x:0,y:size.y*scale};
            }else if (index === vm.selectedData.length-1) {
                typeIcon = 'finish-route';
                size={x:15,y:20};
                scale=1.5;
                anchorPoint = {x:0,y:size.y*scale};
            }else if (data.gpio2 && data.speed === 0) { // Icono Stop
                typeIcon = 'icon-stop-route';
            }else if (data.speed > 0) { // Icono Movimiento

                var dir = '';
                if((data.grados >= 0 && data.grados <= 0 + 22.5) ||
                    (data.grados >= 360 - 22.5 && data.grados <= 360)){ dir = '-270'; } //TOP
                if(data.grados >= 45 - 22.5 && data.grados <= 45 + 22.5){ dir = '-315'; } //TOP-RIGHT
                if(data.grados >= 90 - 22.5 && data.grados <= 90 + 22.5){ dir = ''; } //RIGHT
                if(data.grados >= 135 - 22.5 && data.grados <= 135 + 22.5){ dir = '-45'; } //BOTTOM-RIGHT
                if(data.grados >= 180 - 22.5 && data.grados <= 180 + 22.5){ dir = '-90'; } //BOTTOM
                if(data.grados >= 225 - 22.5 && data.grados <= 225 + 22.5){ dir = '-135'; } //BOTTOM-LEFT
                if(data.grados >= 270 - 22.5 && data.grados <= 270 + 22.5){ dir = '-180'; } //LEFT
                if(data.grados >= 315 - 22.5 && data.grados <= 315 + 22.5){ dir = '-225'; } //TOP-LEFT
                typeIcon = 'icon-move-route' + dir;

            }else if (!data.gpio2 && data.speed === 0) { // Icono ralenti
                typeIcon = 'icon-ralenti-route';
            }else {
                typeIcon = 'icon-alert-route';
            }

            return {
                url:'content/img/' + typeIcon + '.png',
                scaledSize: {width:size.x * scale,height:size.y * scale},
                origin: {x:0,y:0},
                anchor: anchorPoint === null? {x:size.x*scale/2,y:size.y*scale/2} : {x:anchorPoint.x,y:anchorPoint.y}
            };
        }

        function onSelectVehiculosClick(obj) {
            vm.titleCombo = obj.nombre;
            vm.flota.selected = obj; 
          //falta hacer filto en el mapa
           
        }



        /* PRIVATE FUNCTIONS */
        function resizeMap(){
            NgMap.getMap('mapaRecorridos').then( function(map){
                var center = map.getCenter();
                $scope.google.maps.event.trigger(map,'resize');
                map.setCenter(center);
            });
        }

        function zoomToIncludeMarkers() {
            var bounds = new google.maps.LatLngBounds();
            var nLocations = 0;
            nLocations += addToBounds(bounds, vm.selectedData);
            if(nLocations === 0){ return;}
            fitToBounds(bounds);
        }

        function addToBounds(bounds, locations){
            var nLocations = 0;
            locations.forEach(function(location) {
                if(location.lat && location.lng){
                    var latLng = new google.maps.LatLng(location.lat, location.lng);
                    bounds.extend(latLng);
                    nLocations++;
                }
            });
            return nLocations;
        }

        function fitToBounds(bounds){
            NgMap.getMap('mapaRecorridos').then( function(map){
                map.fitBounds(bounds);
                if(map.zoom > MIN_ZOOM) { map.setZoom(MIN_ZOOM); } //Minimun zoom
            });
        }

        function chartClick(xValue){
            //If outside selection remove selection
            if(xValue < vm.selectedData[0].x || xValue > vm.selectedData[vm.selectedData.length - 1].x){ 
                removeSelection();
            }else{ 
                goToValue(xValue);
            }
        }

        function goToStep(index){
            if(index < 0 || index >= vm.selectedData.length){ return; }
            step = index;
            vm.mapData = vm.selectedData.slice(0, step + 1);
            drawMarkers();
            movePlotLine(vm.selectedData[step].x);
            markerClick(null, step);
        }
        
        function addMarkers(){
            for(var j = 0; j < markers.length; j++){
                markers[j].setMap(null);
            }
            markers = [];
            NgMap.getMap('mapaRecorridos').then( function(map){
                for(var i = 0; i < vm.selectedData.length; i++){
                    let marker = new google.maps.Marker({
                        position: {lat:vm.selectedData[i].lat, lng:vm.selectedData[i].lng},
                        title: vm.selectedData[i].speed + ' Km/s',
                        icon: vm.getMarketIcon(vm.selectedData[i], i),
                        map: map,
                        index: i
                    });

                    marker.addListener('click',
                        function(){
                            markerClick(null, marker.index);
                        }
                    );

                    markers.push(marker);
                    vm.selectedData[i].marker = markers.length - 1;
                }
            });
        }

        function drawMarkers(){
            /* jshint maxcomplexity:false */
            NgMap.getMap('mapaRecorridos').then( function(map){
                for(var i = 0; i < markers.length; i++){
                    if(i === vm.mapData[0].marker || i === vm.selectedData[vm.selectedData.length-1].marker){ 
                        if(markers[i].map === null){
                            markers[i].setMap(map);
                        }
                    } else if(vm.mapZoom <=  MARKER_ZOOM){
                        markers[i].setMap(null);
                    } else if(i >= vm.mapData[0].marker && i <= vm.mapData[vm.mapData.length-1].marker){
                        if(markers[i].map === null){
                            markers[i].setMap(map);
                        }
                    } else {
                        if(markers[i].map !== null){
                            markers[i].setMap(null);
                        }
                    }
                }
            });
        }

        function goToStepEnd(){
            goToStep(vm.selectedData.length - 1);
        }

        function goToValue(value){
            for(var i = 0; i < vm.selectedData.length; i ++){
                if(value < vm.selectedData[i].x){
                    step = i;
                    goToStep(i);
                    return;
                }
            }
        }

        function removeSelection(){
            vm.selectedData = vm.data;
            var chartObj = vm.chartConfig.getChartObj();
            chartObj.xAxis[0].removePlotBand('selected-mask');
            addMarkers();
            goToStepEnd();
            zoomToIncludeMarkers();
        }
        
        function addSelection(minDate, maxDate){
            vm.selectedData = [];
            for(var i = 0; i < vm.data.length; i++){
                if(vm.data[i].x >= minDate && vm.data[i].x <= maxDate){
                    vm.selectedData.push(vm.data[i]);
                } 
            }

            var xAxis = vm.chartConfig.getChartObj().xAxis[0];
            xAxis.removePlotBand('selected-mask');
            xAxis.addPlotBand({
                id: 'selected-mask',
                from: minDate,
                to: maxDate,
                color: 'rgba(0, 0, 0, 0.2)'
            });

            addMarkers();
            goToStepEnd();
            zoomToIncludeMarkers();
        }
        
        function movePlotLine(value) {
            if (vm.hideGraph == false) {
                var xAxis = vm.chartConfig.getChartObj().xAxis[0];
                xAxis.removePlotLine('plot-line-1');
                plotLine = {
                    value: value,
                    color: 'red',
                    width: 2,
                    id: 'plot-line-1',
                    zIndex: 100
                };
                xAxis.addPlotLine(plotLine);
            }
           
        }

        function getAddress(lat, long) {
            var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(
                parseFloat(lat), 
                parseFloat(long)
            );

            var deferred = $q.defer();
            geocoder.geocode(
                { 'latLng': latlng },
                function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        if (results[0]) {
                            /*jshint camelcase: false */
                            deferred.resolve(results[0].formatted_address); return;
                        }
                    }
                    deferred.reject('Dirección no encontrada');
                }
            );
            return deferred.promise;
        }

        function parseDataForChart(data){
            for(var i = 0; i < data.length; i++){
                data[i].x = getUTCFromISOString(data[i].lastPositionDate);
                data[i].y = data[i].speed;

                if(i === 0){
                    data[i].distLast = 0;
                    data[i].dist = 0;
                }else{
                    data[i].distLast = getDistance(data[i-1], data[i]);
                    data[i].dist = data[i - 1].dist + data[i].distLast;
                }
            }
        }

        function getUTCFromISOString(isoString){
            var date = isoString && new Date(isoString);
            return date.getTime() -date.getTimezoneOffset() * 60000;
        }

        function findByProperty(array, property, id) {
            for (var i = 0; i < array.length; i++) {
                if (array[i][property] === id) {
                    return array[i];
                }
            }
            return null;
        }

        function getDistance(p1, p2) {
            var R = 6378137; // Earth’s mean radius in meters
            var dLat = rad(p2.lat - p1.lat);
            var dLong = rad(p2.lng - p1.lng);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
                Math.sin(dLong / 2) * Math.sin(dLong / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;
            return d; // returns the distance in meters
        }

        function rad(x) {
            return x * Math.PI / 180;
        }

        function showDetail(e) {
            var $div = $(e.currentTarget).parents('.marker-recorridos').eq(0);
            $div.toggleClass('display');
            vm.wasOpened = $div.hasClass('display');
        }

        function hideDetail(e) {
            var $div = $(e.currentTarget).parents('.marker-recorridos').eq(0);
            $div.removeClass('display');
            vm.wasOpened = false;
        }

        function iconTypeOrder(data) {
            var typeIcon = '';
            // Icono Stop
            if (!data.power && data.speed === 0) {
                typeIcon = 'icon-stop';
            }
            // Icono Movimiento
            else if (data.speed > 0) {
                typeIcon = 'icon-move';
            }
            // Icono ralenti
            else if (data.power && data.speed === 0) {
                typeIcon = 'icon-ralenti';
            }
            // Icono alert
            //if (!data.isLocalized) {
            //    typeIcon = 'icon-alert';
            //}
            
            return typeIcon;
        }
    }

})();